import styled, { createGlobalStyle, css } from 'styled-components';
import { FULL_SCREEN_CLASS } from './FullScreenLayout.constants';

const fullScreenStyles = css`
  overflow: hidden;

  /** dimensions */
  height: 100vh;
  max-height: 100vh;
  width: 100vw;
  max-width: 100vw;

  /** layout */
  display: flex;
  flex: 1 1 auto;
  align-items: stretch;
  justify-content: stretch;
  align-content: stretch;
`;

export const FullScreenAppWrapper = styled.div`
  ${fullScreenStyles}
`;

export const GlobalStyle = createGlobalStyle`
  html.${FULL_SCREEN_CLASS} {
    ${fullScreenStyles}

    & body {
      ${fullScreenStyles}
    }
  }
`;
